<div class="special-box relative-left margin-top-45 full-width logo-flat-{{'logoFlat' | translate }}" [ngClass]="setClass">
  <div class="special-box-content relative-left full-width light-2">
    <div class="special-box-logo absolute top-0 left-0 full-width txt-center" [ngClass]="{'rays-box': raysBox}">
      <div class="special-box-rays full-height absolute top-0 left-50p flex row wrap y-items-center x-content-center">
        <div class="special-box-circle relative circle">
          <figure class="relative margin-auto full-height full-width">
            <ng-container *ngIf="systemLogo; else lotto">
              <img *ngIf="sys == 'wt'" [attr.src]="'https://d3tmfelegj51yl.cloudfront.net/brand/'+sys+'/iso.png'" alt="" />
              <img *ngIf="sys == 'ltk'" [attr.src]="'https://d3tmfelegj51yl.cloudfront.net/brand/'+sys+'/crown.png'" alt="" />
            </ng-container>
            <ng-template #lotto>
              <app-logo-lotto></app-logo-lotto>
            </ng-template>
          </figure>
        </div>
      </div>
    </div>
    <ng-content></ng-content>
  </div>
</div>
